export { actionIconOverrides } from "./ActionIcon.config";
export { ActionIcon } from "@mantine/core";
export type { ActionIconProps } from "@mantine/core";
